const initialState = {
  newTransportForm: false,
  fundingSTOPBilltoOrganization: '',
  departingSAPorJailDepartureLocation: '',
  organizationPerformingPickUpInitial: '',
  communityProviderFacility: '',
  fundingSTOPContact: '',
  SAPTransitionalCounselor: '',
  personPerformingPickInitialDeparture: '',
  personReceivingDestination: '',
  source: '',
  highControl: '',
  specialTransport: '',
  planIncludesFlight: '',
  SASCARepresentativeTransportationCoordinator: '',
  transportCompletedByOrganization: '',
  initialDepartureDate: null,
  dateSAPConfirmedRelease: null,
  SAPStaffConfirmingRelease: '',
  actualDepartureDate: null,
  outcome: '',
  whoContactedConfirmationCallmadeto: '',
  contactedByConfirmationCallmadeby: '',
  callDate: null,
  callTime: null,
  staffTime1By4hrs: null,
  mileage: null,
  estimatedICDTPFlatFee: null,
  StaffTimeQty: null,
  staffTimeOverTime: null,
  staffTimeRate: null,
  staffTimeAmount: null,
  mileageQty: null,
  mileageRate: null,
  mileageAmount: null,
  ICDTPFlatFee: null,
  totalCombinedActualCosts: null,
  comments: null,
  Void: false,
  schedules: [],
};

export default initialState;
